"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var storeRouter = {
  path: '/store',
  component: _layout.default,
  redirect: '/store/index',
  name: 'Store',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/index'));
      });
    },
    name: 'StoreIndex',
    meta: {
      title: '商品管理',
      icon: ''
    }
  }, {
    path: 'sort',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/sort/index'));
      });
    },
    name: 'Sort',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/storeAttr/index'));
      });
    },
    name: 'SortAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/storeComment/index'));
      });
    },
    name: 'StoreComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    path: 'list/creatProduct/:id?/:isDisabled?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/creatStore/index'));
      });
    },
    name: 'SortCreat',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: 'guarantee',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/guarantee/index'));
      });
    },
    name: 'StoreGuarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'commentSetting',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/commentSetting/index'));
      });
    },
    name: 'commentSetting',
    meta: {
      title: '评论设置',
      icon: ''
    }
  }, {
    path: 'tasks',
    name: 'tasks',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/store/virtualSalesTask/Index.vue'));
      });
    },
    meta: {
      title: '定时任务'
    },
    children: [{
      path: 'list',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/store/virtualSalesTask/List/Index.vue'));
        });
      },
      name: 'goodsTaskList',
      meta: {
        title: '任务列表'
      }
    }, {
      path: 'log',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/store/virtualSalesTask/Log/Index.vue'));
        });
      },
      name: 'goodsTaskLog',
      meta: {
        title: '任务日志'
      }
    }]
  }]
};
var _default = exports.default = storeRouter;